import { Legend } from './Legend';

// TODO: in v9, move styled() from Legend.jsx to here
export var StyledLegend = Legend;